<div *ngIf="widgets?.length">
  <div *ngFor="let widget of widgets">
    <div [appLoader]="widget!.type" [props]="widget"></div>
  </div>
</div>